import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '@services/config/config.service';
import {SearchResultsProcessor} from '@formbird/shared';
import {AvlAtLocationGmapComponentDefinition} from './avl-at-location-gmap.component.definition';
import {FormbirdInjectorService, SearchService} from 'formbird-services';
import {SclUtilAvlService, SclUtilGmapService} from 'formbird-sc-shared';
import {SclMapConstantService} from '../../../../formbird-mapping/src/lib/scl-map-constant.service';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import * as GoogleMapsLoader from '../../../../formbird-mapping/src/lib/google/GoogleMapsLoader.js';
import * as moment from 'moment';
import {DataTableImport} from './datatables.import';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ChangedDocumentService} from 'formbird-services';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';

// import { AvlTestData } from './avl-test-data';

declare var $;

@Component({
  templateUrl: './avl-at-location-gmap.component.html',
  styleUrls: [
    './avl-at-location-gmap.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvlAtLocationGmapComponent extends AbstractComponent<AvlAtLocationGmapComponentDefinition> implements OnInit {

  @ViewChild('targetMap', {static: false}) target: ElementRef;
  @ViewChild('elTable', {static: true}) elTable: ElementRef;
  @ViewChild('elAutoComplete', {static: true}) elAutoComplete: ElementRef;
  // services
  notificationService: any;
  dataService: any;
  loggedInUserService: any;

  //
  google;
  map;
  timeFormat = 'hh:mm a';
  tooltipConfig;
  vehicleMainImageFileField;
  vehiclePhoneNumber;
  table;
  grid = {};
  markers = [];
  polyLines = [];
  locationMarker;
  previousPopup;
  geozonesQuery = '';
  geozonesData = '';
  geozonesName = '';
  // apiKey = 'AIzaSyDr8ovTk9O_JVvCokeaFE6nzsbhMRBCQm8'; // avl-dev server
  apiKey = 'AIzaSyDLF3KfOk7figOYUQAudATOTTqCbzf1ylc'; // localhost:3000
  mapParameters;
  defaultLat = -37.8034619371937;
  defaultLon = 144.89993237404;
  defaultZoom = 4;
  zoomAddress = 16;
  mapVehicles = {};
  autocomplete;
  autocompleteURL = 'https://www.geocode.farm/v3/json/forward/?addr='; // combine
  displayArrorHeads;
  maxPoints;
  firstTime = true;
  startDate;
  endDate;
  proccessEventTime = 0;
  proccessVehicleTime = 0;
  vehicleData;
  dataTable;

  constructor(
    public cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclUtilGmapService: SclUtilGmapService,
    private sclUtilMapService: SclUtilMapService,
    private sclUtilAvlService: SclUtilAvlService,
    private configService: ConfigService,
    private httpClient: HttpClient,
    private searchService: SearchService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
  }

  ngOnInit() {

    this.componentSetupService.setupStandardProperties(this);

    if (!(typeof this.componentDefinition.defaultZoom === 'undefined' || this.componentDefinition.defaultZoom === null)) {
      this.defaultZoom = this.componentDefinition.defaultZoom;
    }
    if (!(typeof this.componentDefinition.mapParameters === 'undefined' || this.componentDefinition.mapParameters === null)) {
      this.mapParameters = this.componentDefinition.mapParameters;
      this.defaultLat = this.mapParameters.defaultLat;
      this.defaultLon = this.mapParameters.defaultLon;
      this.defaultZoom = this.mapParameters.zoom;
    }
    const clientConfig = this.configService.clientConfig();
    if (clientConfig) {
      if (clientConfig.googleMapsKey) {
        this.apiKey = clientConfig.googleMapsKey;
      }
      if (clientConfig.dateFormat && clientConfig.dateFormat.time) {
        this.timeFormat = clientConfig.dateFormat.time;
      }
    }

    if (!(typeof this.componentDefinition.tooltipsTable === 'undefined' || this.componentDefinition.tooltipsTable === null)) {
      this.tooltipConfig = this.componentDefinition.tooltipsTable;
    }
    if (!(typeof this.componentDefinition.image === 'undefined' || this.componentDefinition.image === null)) {
      this.vehicleMainImageFileField = this.componentDefinition.image;
    }
    if (!(typeof this.componentDefinition.geozones === 'undefined' || this.componentDefinition.geozones === null)) {
      if (this.componentDefinition.geozones.filter) {
        this.geozonesQuery = this.componentDefinition.geozones.filter;
      }
      if (this.componentDefinition.geozones.data) {
        this.geozonesData = this.componentDefinition.geozones.data;
      }
      if (this.componentDefinition.geozones.name) {
        this.geozonesName = this.componentDefinition.geozones.name;
      }
    }
    if (!(typeof this.componentDefinition.displayArrorHeads === 'undefined' || this.componentDefinition.displayArrorHeads === null)) {
      this.displayArrorHeads = this.componentDefinition.displayArrorHeads;
    }
    if (!(typeof this.componentDefinition.maxPoints === 'undefined' || this.componentDefinition.maxPoints === null)) {
      this.maxPoints = this.componentDefinition.maxPoints;
    }
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 1);
    const strStart = 'dateTimeStart';
    this.document[strStart] = this.startDate;
    const strEnd = 'dateTimeEnd';
    this.document[strEnd] = new Date();

    const importDatatable = new DataTableImport();
    importDatatable.loadExtensions().then(() => {
      this.initTable();
    }, (err) => {
      console.log('Error loading datatable extensions: ' + err.msg);
    });

    this.loadMap(() => {
      console.log('GoogleMapsLoader loaded');
      if (typeof this.componentDefinition.heightNum === 'undefined' || this.componentDefinition.heightNum === null) {
        this.target.nativeElement.style.height = '180 px';
      } else {
        let height = 180 * this.componentDefinition.heightNum;
        const docHeight = document.body.scrollHeight;
        if (height > (docHeight - 180)) {
          height = docHeight - 180;
        }
        this.target.nativeElement.style.height = '' + height + 'px';
      }

      const uluru = { lat: this.defaultLat, lng: this.defaultLon };
      this.map = new this.google.maps.Map(this.target.nativeElement, {zoom: this.defaultZoom, center: uluru});
      this.map.addListener('dragend', this.refreshData.bind(this));
      this.map.addListener('zoom_changed', this.refreshData.bind(this));

      this.autocomplete = new this.google.maps.places.Autocomplete(
        this.elAutoComplete.nativeElement,
        { types: ['geocode'] });

      this.google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
        const place = this.autocomplete.getPlace();

        if (place && place.geometry && place.geometry.location) {
            const lat = place.geometry.location.lat();
            const long = place.geometry.location.lng();
            const location = new this.google.maps.LatLng(lat, long);
            this.map.setCenter(location);
            this.map.setZoom(this.zoomAddress);

            if (this.locationMarker) {
              this.locationMarker.setMap(null);
            }
            this.locationMarker = new this.google.maps.Marker({
                icon: SclMapConstantService.MAP_MARKER,
                position: location,
                map: this.map
            });
        }

      });

      const MapLabel = this.sclUtilGmapService.initMapLabel(this.google);
      if (this.geozonesQuery && this.geozonesData) {
        // var options = scope.sclUtilMap.constructQueryVehicleData(imeis, scope.doc);
        const options = this.sclUtilMapService.constructQueryGeoZones(this.geozonesQuery, this.document);   // testing
        // getGeoZones
        this.searchService.search(options).then((data) => {
          console.log('getGeoZones result = ', data);
          this.sclUtilGmapService.getGeoCoors(SearchResultsProcessor, data, this.geozonesData, this.geozonesName, this.google
            , (geozones) => {
              for (let i = 0 ; i < geozones.length; i++) {
                const geozone = geozones[i];
                if (geozone.shape === 'Point') {
                  const mapLabel: any = new MapLabel({
                          text: geozone.name,
                          position: geozone.coors[0],
                          map: this.map,
                          fontSize: 20
                    });
                  const marker = new this.google.maps.Marker({
                    position: geozone.coors[0]
                  });
                  marker.setMap(this.map);
                } else if (geozone.shape === 'Line') {
                  if (this.geozonesName) {
                    const textCoor = this.centerOfZone(geozone.coors);
                    const mapLabel = new MapLabel({
                        text: geozone.name,
                        position: textCoor,
                        map: this.map,
                        fontSize: 20
                    });
                  }
                  const polyline = new this.google.maps.Polyline({
                    path: geozone.coors,
                    editable: false,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 2
                  });
                  polyline.setMap(this.map);
                } else if (geozone.shape === 'Polygon') {
                  if (this.geozonesName) {
                    const textCoor = this.centerOfZone(geozone.coors);
                    const mapLabel = new MapLabel({
                      text: geozone.name,
                      position: textCoor,
                      map: this.map,
                      fontSize: 20
                    });
                  }
                  const polyline = new this.google.maps.Polygon({
                    path: geozone.coors,
                    editable: false,
                    strokeColor: '#FF0000',
                    strokeOpacity: 1.0,
                    strokeWeight: 2
                  });
                  polyline.setMap(this.map);
                } else {
                  console.log('not handles yet!!!');
                }
              }
            });
        });
      }

    }); // end loadMap

  } // end ngOnInit

  loadMap(cb) {
    GoogleMapsLoader.KEY = this.apiKey;
    GoogleMapsLoader.LIBRARIES = 'places';
    GoogleMapsLoader.SENSOR = true;
    GoogleMapsLoader.load((google) => {
      this.google = google;
      cb();
    });
  }

  getPointFeature(location , image) {
    const marker = new this.google.maps.Marker({
      icon: image,
      position: location
    });

    return marker;
  }
  clearMap() {
    for (const id in this.markers) {
      if (this.markers.hasOwnProperty(id)) {
        this.markers[id].setMap(null);
      }
    }

    this.markers = [];


    for (const id in this.polyLines) {
      if (this.polyLines.hasOwnProperty(id)) {
        this.polyLines[id].setMap(null);
      }
    }

    this.polyLines = [];
  }
  centerOfZone(coordinates) {
    let lat = 0;
    let lng = 0;
    if (coordinates.length <= 0) {
      return;
    }
    for (let i = 0; i < coordinates.length; i++) {
      lat = lat + coordinates[i].lat();
      lng = lng + coordinates[i].lng();
    }
    return new this.google.maps.LatLng(lat / coordinates.length, lng / coordinates.length);
  }
  getDateInfo(date) {

    let startDate = new Date(this.startDate ? this.startDate : null);
    startDate = new Date(startDate.getTime());
    console.log('Offset Time: ' + startDate.getTimezoneOffset()
     + '\tstartDate.getTime(): ' + startDate.getTime() + '\tTestDate: ' + startDate);

    let endDate = new Date(this.endDate ? this.endDate : null);
    endDate = new Date(endDate.getTime());

    const startDateFormat = startDate.toISOString();
    const endDateFormat = endDate.toISOString();

    const args = [];
    args.push(startDateFormat);
    args.push(endDateFormat);

    return args;
  }
  proccessData(data) {
    const customData = data.data;
    console.log('Event number is ' + customData.length);
    if (customData && customData.length > 0) {
        if (this.maxPoints && customData.length > this.maxPoints) {
          console.log('Too much data: ' + customData.length);
          this.notificationService.printMessage('Too much data selected: ' + customData.length + ', please zoom in closer');
          return;
        }
        this.clearMap();
        this.proccessEventTime++;

        const mapTempVehicles = {};
        for (let i = 0; i < customData.length; i++) {
          const valJson = customData[i];
          const vehicleRel: any = this.sclUtilAvlService.getRelatedDocument(valJson, 'vehicle');


          if (vehicleRel && vehicleRel.documentId) {
            if (!mapTempVehicles[vehicleRel.documentId]) {
              mapTempVehicles[vehicleRel.documentId] = {};
            }


          }
        }

        const vehicleIDs = [];


        for (const id in mapTempVehicles) {
          if (!mapTempVehicles[id]) {
            vehicleIDs.push(id);
          }
        }

        if (vehicleIDs.length > 0) {
          const options = this.sclUtilMapService.constructQueryDocument(vehicleIDs, this.document);
          // getVehicleData
          this.searchService.search(options).then( (data: any) => {
              const result = data.data.hits.hits;
              for (let i = 0; i < result.length; i++) {
                const docID = result[i]._source.documentId;
                this.mapVehicles[docID] = result[i];
              }

              this.processVehicleData(mapTempVehicles, customData);


          });
        } else  {
          this.processVehicleData(mapTempVehicles, customData);
        }



    } else {
        this.notificationService.printMessage('No data');
        if (this.table) {
          this.table.clear();
          this.table.draw();
        }

        this.clearMap();
    }
  }
  processVehicleData(mapTempVehicles, customData) {
    console.log('proccess vehicle data ' + this.proccessVehicleTime + '/' + this.proccessEventTime);
    if (this.proccessVehicleTime < this.proccessEventTime - 1) {
      this.proccessVehicleTime = this.proccessEventTime;
      return;
    }
    this.proccessVehicleTime = this.proccessEventTime;
    // vehicle data
    for (const id in mapTempVehicles) {
      if (mapTempVehicles.hasOwnProperty(id)) {
        mapTempVehicles[id].data = mapTempVehicles[id];
      }
    }
    // vehicle's event
    for (let j = 0; j < customData.length; j++) {
        const valJson = customData[j];
        const vehicleRel: any = this.sclUtilAvlService.getRelatedDocument(valJson, 'vehicle');
        if (vehicleRel) {
          const eventId = vehicleRel.documentId;
          if (!mapTempVehicles[eventId].events) {
            mapTempVehicles[eventId].events = [];
          }
          mapTempVehicles[eventId].events.push(valJson);
        }
    }
    for (const id in mapTempVehicles) {
      if (mapTempVehicles.hasOwnProperty(id)) {
        const vehicle = mapTempVehicles[id];
        const listEvent = mapTempVehicles[id].events;
        if (listEvent.length >= 1) {
            vehicle.startDate = listEvent[0].eventDate;
            vehicle.endDate = listEvent[listEvent.length - 1].eventDate;
        }

        this.loadDataForDevice(vehicle.data, vehicle.events, false);
      }
    }

    const tableData = [];
    for (const id in mapTempVehicles) {
      if (mapTempVehicles.hasOwnProperty(id)) {
        tableData.push(mapTempVehicles[id]);
      }
    }
    if (this.table) {
      this.table.clear();
      this.table.rows.add(tableData).draw();
    } else {
      this.initTable();
      this.table.rows.add(tableData).draw();
    }
  }

  loadDataForDevice(vehicle, data, isFit) {

    const results = [];

    for (let j = 0; j < data.length; j++) {
      const valJson = data[j];

      const icon = this.sclUtilMapService.checkAVLSpeed(SclMapConstantService.AVL_SPEED_BEGINNING,
          parseFloat(valJson.speedKPH).toFixed(5),
          parseFloat(valJson.heading), 5, 20, 50, 100, 150);
      const res = this.sclUtilMapService.parseAVLData_New(valJson);
      res.icon = icon;
      res.vehicle = this.sclUtilAvlService.getRelatedDocument(valJson, 'vehicle');
      results.push(res);
    }
    this.showMap(vehicle, results, isFit);
  }
  refreshData() {

    const zoom = this.map.getZoom();
    if (zoom < 10) {
        return;
    }
    const top = this.map.getBounds().getNorthEast().lat();
    const right = this.map.getBounds().getNorthEast().lng();

    const bot = this.map.getBounds().getSouthWest().lat();
    const left = this.map.getBounds().getSouthWest().lng();

    //   var bottomLeft = new google.maps.LatLng(bot,right);
    //  var topRight = new google.maps.LatLng(top,left);
    const bottomLeft = [left, bot];
    const topRight = [right, top];
    const currentDate = new Date();
    const dates = this.getDateInfo(currentDate);

    console.log('apiGetAllAvlEventWithinRange: calculated start date: ' + dates[0] + '\tcalculated end date: ' + dates[1]);

    console.log(bottomLeft.toString());
    console.log(topRight.toString());
    const params = {
      functionName: 'getAllAvlEventWithinRange',
      componentDocumentName: 'sc-avl-at-location-gmap',
      functionParameters: [this.componentDefinition.dataService, dates[0], dates[1], bottomLeft, topRight]
    };
    // apiGetAllAvlEventWithinRange
    this.httpClient.post('api/execute', params).subscribe((customData: any) => {
      this.proccessData(customData);
    });
  }
  showMap(vehicle, data, isFit) {
    // console.log("=========vehicle data");
    // console.log(vehicle);
    const vehicleData = vehicle._source;
    if (data.length === 0) {
      return;
    }
    const listCoordinate = [];
    for (let i = 0; i < data.length - 1; i++) {

      const coordinate = new this.google.maps.LatLng(data[i].latitude, data[i].longitude);
      listCoordinate.push(coordinate);

      const arrow = new this.google.maps.Marker({
        map: this.map,
        icon: data[i].icon,
        position: coordinate
      });
      arrow.data = data[i];
      const self = this;
      arrow.addListener('mouseover', function() {

          if (this.previousPopup) {
            this.previousPopup.close();
          }

          let vehicleName = '';
          let url = '';
          if (this.data.vehicle && this.data.vehicle.documentId) {
            url = 'form/' + this.data.vehicle.documentId;
          }
          if (this.data.vehicle && this.data.vehicle.name) {
            vehicleName = '<div><a style="color:#2d24ff" href="' + url + '"><b>' + this.data.vehicle.name + '</b></a></div>';
          }

          let tooltipImg = '';
          let imgtooltip = '';

          if (self.vehicleMainImageFileField && vehicleData[self.vehicleMainImageFileField]
              && Array.isArray(vehicleData[self.vehicleMainImageFileField])
              && vehicleData[self.vehicleMainImageFileField].length > 0) {

              const imageData = vehicleData[self.vehicleMainImageFileField][0];
              tooltipImg = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
              imgtooltip = '<img src=' + tooltipImg + '/>';
          }




          const emei = self.toDataRow('IMEI', this.data.imei);
          const addressRow = self.toDataRow('Address', '');
          const gps = self.toDataRow('GPS', this.data.latitude.toString() + ', ' + this.data.longitude.toString());
          const time = self.toDataRow('Time', self.formatDateTime( this.data.eventDate));
          const speed = self.toDataRow('Speed', this.data.speedKPH);
          const heading = self.toDataRow('Heading', this.data.heading);
          const imageRow = self.toDataRow('Image', imgtooltip);
          const arrayValue = [];
          arrayValue.push(addressRow);
          arrayValue.push(gps);
          arrayValue.push(time);
          arrayValue.push(speed);
          arrayValue.push(heading);

          if (self.tooltipConfig) {
            for (const key1 in self.tooltipConfig) {
              if (self.tooltipConfig.hasOwnProperty(key1)) {
                const key2 = self.tooltipConfig[key1];
                let value = self.sclUtilMapService.parseHandlerBar(key2, vehicleData) ;
                value = value ? value : '';
                const tooltipRow = self.toDataRow(key1, value);
                arrayValue.push(tooltipRow);
              }
            }
          }

          arrayValue.push(imageRow);
          const text = vehicleName + self.toHtmlTable(arrayValue);

          const width = self.target.nativeElement.offsetWidth / 10 * 6;
          // width = Math.min(width, 250);


          const infoWindow = new self.google.maps.InfoWindow({
              content: text,
              position: this.position,
              maxWidth: width
          });
          arrow.infoWindow = infoWindow;
          infoWindow.open(self.map, this);
          self.previousPopup = infoWindow;

          const location = [this.data.longitude, this.data.latitude];
          self.convertGPSToAddress(location, (data1: any) => {
            if (data1 == null) { return; }
            if (arrow.infoWindow) {
              const temp = {properties: {}};
              const address = self.sclUtilMapService.fillGoogleAddress(data1.data.results[0], temp);
              // tslint:disable-next-line: no-shadowed-variable
              let text = (address.properties.streetNo) ? address.properties.streetNo : '';
              text += ' ' + ((address.properties.street) ? address.properties.street : '');
              text += '<br>' + ((address.properties.suburb) ? address.properties.suburb  : '');
              text += '<br> ' + ((address.properties.state) ? address.properties.state : '');
              text += ', ' + ((address.properties.country) ? address.properties.country : '');
              addressRow.col2 = text;
              const arrayValue1 = [];
              arrayValue1.push(addressRow);
              arrayValue1.push(gps);
              arrayValue1.push(time);
              arrayValue1.push(speed);
              arrayValue1.push(heading);
              if (self.tooltipConfig) {
                  for (const key1 in self.tooltipConfig) {
                    if (self.tooltipConfig.hasOwnProperty(key1)) {
                      const key2 = self.tooltipConfig[key1];
                      let value = self.sclUtilMapService.parseHandlerBar(key2, vehicleData) ;
                      value = value ? value : '';
                      const tooltipRow = self.toDataRow(key1, value);
                      arrayValue1.push(tooltipRow);
                    }
                  }
              }
              arrayValue1.push(imageRow);
              text = vehicleName + self.toHtmlTable(arrayValue1);
              arrow.infoWindow.setContent(text);
            }

          });
      });

      this.markers.push(arrow);
    }

    const line = new this.google.maps.Polyline({
      path: listCoordinate,
      editable: false,
      strokeColor: '#FF0000',
      strokeOpacity: 1.0,
      strokeWeight: 2,
      map: this.map
    });
    this.polyLines.push(line);
  }
  formatTime(time) {
    const longDate = 'MMM DD YYYY, h:mm:ss a';
    const timeReturn = moment(time).fromNow() + ' (' + moment(time).format(longDate) + ')';
    return timeReturn;
  }
  formatDateTime(time) {
    const longDate = 'MMM DD YYYY, h:mm:ss a';
    const timeReturn = moment(time).format(longDate);
    return timeReturn;
  }
  toDataRow(col1, col2) {
    const row: any = {};
    row.col1 = col1;
    row.col2 = col2;
    return row;
  }
  toHtmlTable(array) {
    const style = '';
    let tableText = '<table style="width:100%" class = "table-popup">';
    for (let i = 0; i < array.length; i++) {
      tableText += '<tr>';
      tableText += '<td class = "table-popup">' + array[i].col1 + '</td>';
      tableText += '<td class = "table-popup">' + array[i].col2 + '</td>';
      tableText += '</tr>';
    }
    tableText += '</table>';
    return tableText;
  }
  initTable() {
    const self = this;
    this.dataTable = $(this.elTable.nativeElement);
    $.fn.dataTable.ext.errMode = 'throw';
    this.table = this.dataTable.DataTable({
        columns: [
            {
                title: 'Name',
                data: 'data._source.systemHeader.summaryName',
                render: function(data, type, row, meta) {
                    return '<a target="_blank" href="/form/' + row.data._source.documentId + '">' + data + '</a>';
                }
            },
            {
                title: 'First time',
                data: 'startDate',
                render: function(data, type, row, meta) {
                    return self.formatTime(new Date(row.startDate));
                }
            },
            {
                title: 'Last time',
                data: 'endDate',
                render: function(data, type, row, meta) {
                    return self.formatTime(new Date(row.endDate));
                }
            }
        ]
    });
  }
  convertGPSToAddress(coor, cb) {
    const lat = parseFloat(coor[1]);
    const lon = parseFloat(coor[0]);

    const link = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=' + this.apiKey;
    this.httpClient.get(link).subscribe((data: any) => {
        if (data.status === 'OK' ) {
          if (cb && typeof cb === 'function') {
            cb(data);
          }
        } else {
          console.log('Error: ' + data.error_message);
          cb(null);
        }
    }, error => {
      console.log('Error : ' + error);
      cb(null);
    });
  }
  removeStreet() {
    if (this.elAutoComplete) {
      this.elAutoComplete.nativeElement.value = '';
    }

    if (this.locationMarker) {
      this.locationMarker.setMap(null);
    }
  }
  watchDateTimeFieldStart(value) {
    console.log('Change start date = ' + value);
    if (!value) { value = new Date(); }
    this.startDate = value;
    this.refreshData();
  }

  watchDateTimeFieldEnd(value) {
    console.log('Change end date = ' + value);
    if (!value) { value = new Date(); }
    this.endDate = value;
    this.refreshData();
  }
}
